// extracted by mini-css-extract-plugin
export default {"productDescription":"bba-z","featuredDescription":"cba-z","description":"dba-z","more":"eba-z","descriptionSku":"fba-z"};